import React from "react";
var TimelineStep = function (props) {
    var icon = props.icon, title = props.title, actionButton = props.actionButton;
    return (React.createElement("div", { className: "primary-timeline-step-container d-flex w-100 align-items-start justify-content-start" },
        React.createElement("div", { className: "step-icon d-flex flex-column align-items-center justify-content-center" },
            React.createElement("i", { className: "icon ".concat(icon, " txt_lavender-blue") })),
        React.createElement("div", { className: "step-content d-flex flex-column DMSans_13_400" },
            React.createElement("div", { className: "step-title d-flex align-items-center justify-content-start txt_purple-gray" },
                React.createElement("span", { className: "title-text" }, title)),
            actionButton)));
};
export default TimelineStep;
